import Button from "@mui/material/Button";
import React from "react";
import PropTypes from "prop-types";

/**
 * A button that opens a given URL in a new tab.
 *
 * @param {{text: string, url: string, endIcon?: boolean}} props
 * @param {string} props.text The text to show on the button
 * @param {string} props.url The url to open in a new tab
 * @param {object} [props.endIcon=undefined] The end icon to use on the button, default undefined
 * @returns {React.ReactElement} The button
 */
const LinkTextButton = ({text, url, endIcon = undefined}) => {
    return <>
        {endIcon
            && <Button
                variant="text"
                href={url}
                target="_blank"
                rel="noopener noreferrer"
                endIcon={endIcon}>
                {text}
            </Button>}
        {!endIcon
            && <Button
                variant="text"
                href={url}
                target="_blank"
                rel="noopener noreferrer">
                {text}
            </Button>}
    </>;
};

LinkTextButton.propTypes = {
    text: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    endIcon: PropTypes.object
};

export {LinkTextButton};